import React, { useEffect, useState } from 'react'
import './cu-spare.scss'
import NormalInput from '../../common/inputs/NormalInput'
import SelectInput from '../../common/inputs/SelectInput'
import { productTypes, spareCategories, trackingTypes, UNITS } from '../../../assets/javascript/const-data'
import { customerAxios } from '../../../config/axios'
import toast from 'react-hot-toast'
import MultiSelect from '../../common/inputs/MultiSelect'

const CUSpare = ({ currentData, setModal, setData, isEdit }) => {
    const [form, setForm] = useState({})
    const [itemForm, setItemForm] = useState({})

    const handleChange = (e) => {

        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleMultiSelect = (name, e) => {
        setForm({
            ...form,
            [name]: e?.map((v) => v.value)
        })
    }

    const handleChangeItemForm = (e) => {
        setItemForm({
            ...(itemForm || {}),
            [e.target.name]: e.target.value
        })
    }

    const handleAddItem = () => {
        if (!itemForm?.spare_id || !itemForm?.qty) {
            return;
        }

        const existed = form?.item_list?.find(i => i?.spare_id === itemForm?.spare_id)
        if (existed) {
            toast.error('The item Id already exited')
            return
        }

        setForm({
            ...form,
            item_list: [
                ...(form?.item_list || []),
                itemForm
            ]
        })

        setItemForm({})
    }

    const removeItem = (spare_id) => {
        setForm({
            ...form,
            item_list: (form?.item_list || [])?.filter(i => i?.spare_id !== spare_id)
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const body = {
            spare_name: form?.spare_name || null,
            spare_category: form?.spare_category || null,
            tracking_type: form?.tracking_type || null,
            attributes: [],
            applicable_for: form?.applicable_for || [],
            unit: form?.unit || null,
            item_list: form?.item_list?.map(s => ({ item_id: s?.spare_id, qty: s?.qty })) || [],
            package_pricing: [],
            selling_rate: Number(form?.selling_rate) || 0,
            purchase_cost: Number(form?.purchase_cost) || 0,
            warranty_period: Number(form?.default_warranty_period) || 0
        }

        if (form?.BRAND) {
            body?.attributes?.push({ feature_id: 'BRAND', value: form?.BRAND })
        }

        if (form?.COLOR) {
            body?.attributes?.push({ feature_id: 'COLOR', value: form?.COLOR })
        }

        if (form?.SIZE) {
            body?.attributes?.push({ feature_id: 'SIZE', value: form?.SIZE })
        }

        if (isEdit) {
            customerAxios.put(`/production-v0/spare/${currentData?.spare_id}/info`, body).then(() => {
                setModal({ status: false })
                toast.success(`Spare Updated! \n Refresh and Reopen the Spare to View`)

            }).catch((error) => {
                toast.error(error.message)
            })
        } else {
            // Create new associate
            customerAxios.post(`/production-v0/spare`, body).then(() => {
                setModal({ status: false })
                toast.success(`Spare Created! \n Refresh and Reopen the Spare to View`)

            }).catch((error) => {
                toast.error(error.message)
            })
        }
    }

    useEffect(() => {
        if (isEdit) {
            const temp = {
                spare_name: currentData?.spare_name,
                applicable_for: currentData?.applicable_for,
                unit: currentData?.unit,
                item_list: currentData?.item_list?.map(i => ({ spare_id: i?.spare_id, qty: i?.qty })),
                spare_category: currentData?.spare_category,
                selling_rate: currentData?.selling_rate,
                purchase_cost: currentData?.purchase_cost,
                default_warranty_period: currentData?.default_warranty_period
            }

            currentData?.attributes?.forEach((a) => {
                temp[a.feature_id] = a?.value;
            });

            setForm(temp)
        }

        // eslint-disable-next-line
    }, [currentData])


    return (
        <div className="cu-spare-sub-div">
            <form action="" onSubmit={handleSubmit}>
                <div className="input-group-div">
                    <NormalInput label='Spare Name *' name='spare_name' value={form?.spare_name} onChangeFun={handleChange} />
                    <MultiSelect label='Applicable For *' name='applicable_for' values={productTypes?.map((p) => ({ label: p, value: p }))}
                        onChangeFun={(e) => handleMultiSelect('applicable_for', e)} selectedValue={currentData?.applicable_for?.map((p) => ({ label: p, value: p }))}
                        required />
                    <SelectInput label='Unit Type *' name='unit' values={UNITS?.map((u) => ({ option: `${u?.name} (${u?.short})`, value: u?.short, selected: u?.short === form?.unit }))} onChangeFun={handleChange}
                        firstOption={{ option: 'Choose...', value: '' }} />
                    <SelectInput label='Spare Category *' name='spare_category' values={spareCategories?.map((v) => ({ option: v, value: v, selected: v === form?.spare_category }))} onChangeFun={handleChange}
                        firstOption={{ option: 'Choose...', value: '' }} />
                    {!isEdit && <SelectInput label='Tracking Type *' name='tracking_type' values={trackingTypes?.map((v) => ({ option: v, value: v, selected: v === form?.tracking_type }))} onChangeFun={handleChange}
                        firstOption={{ option: 'Choose...', value: '' }} />}
                    <NormalInput label='Selling Rate (SR) *' type={'number'} name='selling_rate' value={form?.selling_rate} onChangeFun={handleChange} min={0} />
                    <NormalInput label='Purchase Cost (PC) *' type={'number'} name='purchase_cost' value={form?.purchase_cost} onChangeFun={handleChange} min={0} />
                    <NormalInput label='Default Warranty (Months) *' type={'number'} name='default_warranty_period' value={form?.default_warranty_period} onChangeFun={handleChange} min={0} />
                </div>
                <h4 style={{ marginTop: "10px" }}>Attributes</h4>
                <div className="input-group-div">
                    <NormalInput label='Brand' name='BRAND' value={form?.BRAND} onChangeFun={handleChange} isRequired={false} />
                    <NormalInput label='Color Name' name='COLOR' value={form?.COLOR} onChangeFun={handleChange} isRequired={false} />
                    <NormalInput label='Size' name='SIZE' value={form?.SIZE} onChangeFun={handleChange} isRequired={false} />
                </div>
                <h4 style={{ marginTop: "10px" }}>Inner Items</h4>
                <div className="item-list-div">
                    <table>
                        <tbody>
                            {form?.item_list?.map((item) => {
                                return <tr>
                                    <td>{item?.spare_id}</td>
                                    <td>Qty : {item?.qty}</td>
                                    <td>
                                        <button type='button' onClick={() => removeItem(item?.spare_id)}>
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="add-item-div">
                    <NormalInput label='Spare Id' name='spare_id' value={itemForm?.spare_id} onChangeFun={handleChangeItemForm} isRequired={false} />
                    <NormalInput label='Qty' name='qty' value={itemForm?.qty} onChangeFun={handleChangeItemForm} isRequired={false} type={'number'} min={1} />
                    <button type='button' onClick={handleAddItem}>Add Item</button>
                </div>
                <button>Submit</button>
            </form>
        </div>
    )
}

export default CUSpare